const Powered = () => {
	return <img src='../../../../assets/img/ufood-x/logo-ufoodx.webp' alt='UFOODX' className='mx-auto h-11' />;
};

export default Powered;
